import generateItemUid from './generate-item-uid'

export default ({product, variation, options = null, sku = null, extraAttribute, optionsIds = null}) => {

    if(!product || (product.type !== 'simple' && (!variation || !options || !Object.keys(options).length))) {return null}

        if(typeof(product.attributes) != "undefined" && product.attributes !== null && options) {
            if(Object.keys(options).length != Object.keys(product.attributes).length){ return null}
        }
        else if(typeof(product.options) != "undefined" && product.options !== null && options) {
            if(Object.keys(options).length != Object.keys(product.options).length){ return null}
        }


    let publishUrl = product.publish_url + '/';
    if(['huge_variations', 'variable'].includes(product.type)) {
        publishUrl = publishUrl.split('?')[0] + '?' + Object.keys(options).filter(i => options[i]).map(attr => `attribute_${attr}=${options[attr]}`).join('&')
    }

    const title = variation && variation.title ? variation.title : product.title

    if(product.grouped_product) {
        product.grouped_product.is_group_of = true
    }

    let stockStatus = product.stock_status;
    
    if(['variable'].includes(product.type)) {
        stockStatus = variation.stock_status
    }

    const item = {
        id: product.id,
        variant_id: variation ? variation.id : null,
        show_in_product: variation ? variation.show_in_product : null,
        publish_url: publishUrl,
        title: title,
        categories: product.categories || [],
        sku: sku || product.sku,
        type: product.type,
        grouped_product: product.grouped_product,
        is_group_of: !!product.is_group_of,
        options: options || {},
        options_ids: optionsIds || {},
        price: (variation ? variation.price : product.price) || 0,
        image: variation && variation.image ? variation.image : product.main_image,
        units: product.units,
        price_label: product.price_label,
        uid: generateItemUid({attributes: (options || {}), e_attribute: extraAttribute}),
        extra_attribute: extraAttribute,
        extra_attribute_options: extraAttribute ? extraAttribute.options : '',
        stock_status: stockStatus,
        cross_sell_products: product.cross_sell_products || [],
        shipping: variation ? variation.shipping : null,
        group_of: product.group_of,
        min_quantity: product.min_quantity,
        quantity: product.quantity,
        max_quantity: product.max_quantity,
        enable_functionality_for_admin: product.enable_functionality_for_admin,
        allow_combination: product.allow_combination,
        threshold_quantity: product.threshold_quantity,
        threshold_enabled: product.threshold_enabled,
    }

    return item
}
